import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageLightbox } from '@/components/common/ImageLightbox';

const brickCategories = [
  // Existing Pavers - General Colors
  {
    name: 'Glacier',
    category: 'General Colors',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/a659nbqh_Glacier.%20jpg.jpg',
    description: 'Cool, contemporary gray tones with subtle variations',
  },
  {
    name: 'Granite',
    category: 'General Colors',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/qui8di57_Granite.jpg',
    description: 'Rich granite finish with natural stone appearance',
  },
  {
    name: 'Lions Bridge',
    category: 'General Colors',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/ti6m2ddn_Lions%20Bridge.%20jpg.png',
    description: 'Premium multi-tone blend with distinctive character',
  },
  {
    name: 'Sand Dune',
    category: 'General Colors',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/r8yacl5q_Sand%20Dune.%20jpg.png',
    description: 'Warm, neutral sand tones for elegant outdoor spaces',
  },
  {
    name: 'Sierra',
    category: 'General Colors',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/ghpbihiz_Sierra.%20jpg.png',
    description: 'Natural earth tones inspired by mountain landscapes',
  },
  
  // NEW - Color Brick (Colorbrake) - Flagstone Collection
  {
    name: 'Cream Tan',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/j660u9tf_Cream%20Tan%20.png',
    description: 'Elegant cream tan flagstone with warm, inviting tones',
  },
  {
    name: 'Cream Orange Pewter',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/56cmo7sa_Cream%20Orange%20Pewter%20.png',
    description: 'Sophisticated blend of cream, orange, and pewter tones',
  },
  {
    name: 'Cream Orange Brown',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/1r1bo9ku_Cream%20Orange%20Brown.png',
    description: 'Rich flagstone blend with cream, orange, and brown highlights',
  },
  {
    name: 'Cream Beige',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/1nhhh6q4_Cream%20Beiger.png',
    description: 'Classic cream beige flagstone for timeless elegance',
  },
  {
    name: 'Cream Beige Charcoal',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/hu459mo1_Cream%20Beige%20Charcoal.png',
    description: 'Dynamic flagstone mix with cream, beige, and charcoal accents',
  },
  
  // NEW BATCH - Additional Flagstone Colors
  {
    name: 'Gray Charcoal',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/8fxsw82c_Gray%20Charcoal%20.%20jpg.png',
    description: 'Contemporary gray charcoal flagstone with modern appeal',
  },
  {
    name: 'Indian Summer',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/kzzen81u_Indian%20Summer.%20jpg%20.png',
    description: 'Warm, earthy flagstone blend inspired by autumn landscapes',
  },
  {
    name: 'Red Charcoal',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/8bt898l0_Red%20Charcoal.%20jpg.png',
    description: 'Bold red and charcoal flagstone combination for dramatic contrast',
  },
  {
    name: 'Red Tan Charcoal',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/uyu639bj_Red%20Tan%20Charcoal.%20jpg%20.png',
    description: 'Premium tri-color flagstone blend with red, tan, and charcoal tones',
  },
  {
    name: 'Tan Charcoal',
    category: 'Color Brick - Flagstone',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/dsbujye2_Tan%20Charcoal.%20jpg.png',
    description: 'Sophisticated tan and charcoal flagstone for elegant outdoor spaces',
  },
  
  // NEW BATCH - Color Brick Claros (Light Tones)
  {
    name: 'White Pewter',
    category: 'Color Brick - Claros',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/h2gja2rw_White%20Pewter.%20jpg.png',
    description: 'Clean white pewter flagstone with contemporary elegance',
  },
  {
    name: 'White Tan',
    category: 'Color Brick - Claros',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/j39a9uj5_White%20Tan.%20jpg.png',
    description: 'Bright white and tan blend for coastal and modern aesthetics',
  },
  {
    name: 'White Tan Charcoal',
    category: 'Color Brick - Claros',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/5zn4fdii_White%20Tan%20Charcoal.%20jpg.png',
    description: 'Premium tri-color blend with white, tan, and charcoal accents',
  },
  
  // NEW BATCH - Paverscape Premium Brand
  {
    name: 'Bishop Hat',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/ua3g3fi1_Bishop%20Hat.%20jpg%20.png',
    description: 'Distinctive Paverscape design with unique architectural pattern',
  },
  {
    name: 'Bentcreek',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/rtht4mjk_Bentcreek.%20jpg%20.png',
    description: 'Premium Paverscape collection with natural stone character',
  },
  {
    name: 'Castlescape',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/mkimcmvx_Castlescape.%20jpg%20.png',
    description: 'Classic castle-inspired paver design with timeless elegance',
  },
  {
    name: 'Cobblescape',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/bk1mbcbk_Cobblescape.jpg.png',
    description: 'Traditional cobblestone pattern with old-world charm',
  },
  {
    name: 'Emerald',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/ozee7mit_Emerald.jpg%20.png',
    description: 'Distinctive emerald paver collection with rich character',
  },
  {
    name: 'Groovestone',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/q9aefg1b_Groovestone.jpg%20.png',
    description: 'Modern grooved stone design for contemporary projects',
  },
  {
    name: 'Boca',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/9qs27n4l_Boca.jpg.png',
    description: 'Premium Boca paver collection with sophisticated styling',
  },
  {
    name: 'Mega Castle',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/0kmrzxc3_Mega%20Castle.jpg%20.png',
    description: 'Oversized castle stone pavers for grand installations',
  },
  {
    name: 'Mega Slate',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/jzctdnfs_Mega%20Slate.%20jpg%20.png',
    description: 'Large-format slate-textured pavers for modern design',
  },
  {
    name: 'Mega Smooth',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/595xntj6_Mega%20Smooth.%20jpg%20.png',
    description: 'Contemporary smooth-finish mega pavers for sleek aesthetics',
  },
  {
    name: 'Square 8x8',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/19zmbfn6_Square%208x8.%20jpg%20.png',
    description: 'Classic 8x8 square pavers for traditional patterns',
  },
  {
    name: 'Square 12x12',
    category: 'Paverscape',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/o50543kw_Square%20%2812%E2%80%B3x12%E2%80%B3%29.png',
    description: 'Large 12x12 square pavers for bold contemporary installations',
  },
  
  // Belgard Premium Collection
  {
    name: 'Adobe',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/vlbeyirz_adobe.%20jpg%20.png',
    description: 'Belgard Adobe collection with warm southwestern charm',
  },
  {
    name: 'Amaretto',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/iyct2hnv_Amaretto.%20jpg%20.png',
    description: 'Rich amaretto tones from Belgard premium line',
  },
  {
    name: 'Charcoal',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/8xl0wxh1_Charcoal.jpg%20.png',
    description: 'Bold charcoal pavers from Belgard for contemporary design',
  },
  {
    name: 'Harvest Blend',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/v266dkml_Harvest%20Blend.jpg%20.png',
    description: 'Multi-tone harvest blend capturing autumn color palette',
  },
  {
    name: "Knight's Bridge",
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/btfjfrvy_Knight%27s%20Bridge.jpg%20.png',
    description: 'Premium Knight\'s Bridge collection with Old World elegance',
  },
  {
    name: 'Napoli',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/ajpwsi6w_Napoli.%20jpg%20.png',
    description: 'Italian-inspired Napoli pavers with Mediterranean character',
  },
  {
    name: 'Rio',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/eke9izrr_Rio.jpg%20.png',
    description: 'Vibrant Rio collection with warm, inviting tones',
  },
  {
    name: 'Slate',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/7dw9fr2a_Slate%2Cjpg%20.png',
    description: 'Natural slate texture with contemporary appeal',
  },
  {
    name: 'Titanium',
    category: 'Belgard',
    image: 'https://customer-assets.emergentagent.com/job_remodel-pros-1/artifacts/dzh2deqi_Titanium.jpg%20.png',
    description: 'Modern titanium finish for sleek, upscale installations',
  },
];

export const BrickColors = ({ onOpenLeadModal }) => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxTitle, setLightboxTitle] = useState('');

  const openLightbox = (image, title) => {
    setLightboxImage(image);
    setLightboxTitle(title);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxTitle('');
  };

  const categories = ['all', 'General Colors', 'Color Brick - Flagstone', 'Color Brick - Claros', 'Paverscape', 'Belgard'];
  const filteredBricks = selectedCategory === 'all' 
    ? brickCategories 
    : brickCategories.filter(brick => brick.category === selectedCategory);

  return (
    <div data-testid="brick-colors-page">
      {/* Hero Section */}
      <section className="py-32 bg-gradient-to-br from-[hsl(215,75%,16%)] to-[hsl(224,64%,33%)] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-bold uppercase tracking-wider">
              Premium Paver Collection
            </span>
          </div>
          <h1
            className="text-5xl sm:text-6xl lg:text-7xl font-black mb-6 tracking-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            Brick Paver Colors & Patterns
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Discover our premium selection of brick pavers - choose the perfect color and pattern for your project
          </p>
        </div>
      </section>

      {/* Category Filter Buttons */}
      <section className="py-8 bg-gray-50 border-b sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-6 py-3 rounded-full font-bold transition-all duration-200 ${
                  selectedCategory === cat
                    ? 'bg-[hsl(215,75%,16%)] text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border-2 border-gray-200'
                }`}
                data-testid={`filter-${cat.toLowerCase().replace(/ /g, '-').replace(/\-/g, '-')}`}
              >
                {cat === 'all' ? 'All Collections' : cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Brick Colors Grid - Clean Professional Layout */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredBricks.map((brick, index) => (
              <div
                key={index}
                className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden premium-card-hover group cursor-pointer shadow-lg hover:border-[hsl(224,64%,33%)]"
                data-testid={`brick-color-${index}`}
                onClick={() => openLightbox(brick.image, brick.name)}
              >
                {/* Image */}
                <div className="relative aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={brick.image}
                    alt={brick.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold text-[hsl(215,75%,16%)] shadow-lg">
                    Click to Enlarge
                  </div>
                  {brick.category && (
                    <div className="absolute top-4 left-4 bg-[hsl(224,64%,33%)]/95 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold text-white shadow-lg">
                      {brick.category}
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3
                    className="text-2xl font-black text-[hsl(215,75%,16%)] mb-3"
                    style={{ fontFamily: 'Outfit' }}
                  >
                    {brick.name}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm mb-4">
                    {brick.description}
                  </p>
                  <button
                    className="w-full btn-premium btn-premium-primary text-sm py-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      // Request samples functionality
                    }}
                  >
                    Request Samples
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="max-w-4xl mx-auto mt-20 text-center">
            <div className="bg-gradient-to-br from-[hsl(215,75%,16%)] to-[hsl(224,64%,33%)] rounded-2xl p-12 text-white shadow-2xl">
              <h3 className="text-3xl font-black mb-4" style={{ fontFamily: 'Outfit' }}>
                Need Help Choosing the Right Paver?
              </h3>
              <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                Our experts can help you select the perfect paver color and pattern for your specific project needs
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={onOpenLeadModal}
                  className="btn-premium btn-premium-secondary text-base px-8 py-4"
                >
                  Schedule Free Consultation
                </button>
                <a 
                  href="tel:+14074510902"
                  className="btn-premium bg-white/10 text-white border-2 border-white hover:bg-white hover:text-[hsl(215,75%,16%)] text-base px-8 py-4 backdrop-blur-sm inline-flex items-center justify-center"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                    <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                  </svg>
                  Call Now: (407) 451-0902
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Lightbox */}
      <ImageLightbox
        isOpen={!!lightboxImage}
        onClose={closeLightbox}
        image={lightboxImage}
        title={lightboxTitle}
      />
    </div>
  );
};
